import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth-provider/auth-provider"

export const PrivateRoute = () => {
    const auth =  useAuth();
    if(!auth.token) return <Navigate to="/login" />;
    return <Outlet />;
}